import action from "../common";
export default action("PROFILE");
